import { render, staticRenderFns } from "./userTagsDialog.vue?vue&type=template&id=0a48b4b2"
import script from "./userTagsDialog.vue?vue&type=script&lang=js"
export * from "./userTagsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports